import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next'; // 1. Import the hook
import videoBackground from '../assets/video/mid.mp4';

const CustomTripSection = () => {
  const { t } = useTranslation(); // 2. Initialize the translation function

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100vw',
        minHeight: { xs: '90vh', md: '100vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        color: 'white',
      }}
    >
      {/* Video Background */}
      <Box
        component="video"
        autoPlay
        loop
        muted
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 1,
        }}
      >
        <source src={videoBackground} type="video/mp4" />
        {/* 3. Use t() for fallback text */}
        {t('cta_video_fallback')}
      </Box>

      {/* Dark Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 2,
        }}
      />

      {/* Content */}
      <Container
        maxWidth="xl"
        sx={{
          position: 'relative',
          zIndex: 3,
          textAlign: 'center',
          py: 4,
        }}
      >
        <Typography
          variant="h3"
          component="h2"
          fontWeight="bold"
          gutterBottom
          sx={{
            textShadow: '2px 2px 8px rgba(0,0,0,0.7)',
            fontSize: { xs: '2.2rem', sm: '2.8rem', md: '3.5rem' },
            fontFamily: 'serif',
          }}
        >
          {/* 3. Use t() for the headline */}
          {t('cta_headline')}
        </Typography>
        <Typography
          variant="h6"
          component="p"
          sx={{
            my: 3,
            fontSize: { xs: '1rem', md: '1.25rem' },
            maxWidth: '900px',
            mx: 'auto',
          }}
        >
          {/* 3. Use t() for the paragraph */}
          {t('cta_paragraph')}
        </Typography>
        <Button
          variant="contained"
          size="large"
          endIcon={<ArrowForwardIcon />}
          sx={{
            backgroundColor: '#FF9933',
            color: 'white',
            fontWeight: 'bold',
            borderRadius: '50px',
            padding: { xs: '12px 24px', md: '15px 30px' },
            fontSize: { xs: '1rem', md: '1.1rem' },
            transition: 'transform 0.3s ease, background-color 0.3s ease, padding 0.3s ease',
            '& .MuiButton-label, & .MuiButton-root > span:not(.MuiButton-endIcon)': {
              transition: 'transform 0.3s ease-in-out',
            },
            '& .MuiButton-endIcon': {
              transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
              opacity: 0,
              transform: 'translateX(-10px)',
            },
            '&:hover': {
              backgroundColor: '#E5892D',
              transform: 'scale(1.05)',
              paddingRight: { xs: '20px', md: '24px' },
              '& .MuiButton-label, & .MuiButton-root > span:not(.MuiButton-endIcon)': {
                transform: 'translateX(-5px)',
              },
              '& .MuiButton-endIcon': {
                opacity: 1,
                transform: 'translateX(0)',
              },
            },
          }}
        >
          {/* 3. Use t() for the button text */}
          {t('cta_button')}
        </Button>
      </Container>
    </Box>
  );
};

export default CustomTripSection;